import { fetchPostJSON } from './fetchPostJSON'

export const createBillingCheckout = async ({
  stripeID,
}: {
  stripeID: string
}) => {
  if (!stripeID) {
    throw new Error(
      'User not found for stripeID when creating billing checkout'
    )
  }

  // Create a session for the customer
  const stripeBillingSession = await fetchPostJSON(
    `${process.env.NEXT_PUBLIC_URL}/api/billing_sessions`,
    { stripeID }
  )

  if (stripeBillingSession.statusCode === 500) {
    throw new Error(stripeBillingSession.message)
  }

  // Send customer to checkout or return error
  if (stripeBillingSession.url) {
    return stripeBillingSession.url
  } else {
    throw new Error('No url found in stripeBillingSession')
  }
}
